import { User } from "@/lib/store/features/auth/authSlice";

const canAccessAdmin = (user: User) => {
  return user.roles.includes("ADMIN") || user.roles.includes("SYSTEM_ADMIN");
};

export { canAccessAdmin };
